// extracted by mini-css-extract-plugin
export default {"root":"_3Ti-32C7pfKCg1q-Dc6arp","text":"nCdBXz-xo4MmVWSUUJF9d"};